import { render, staticRenderFns } from "./res-label.vue?vue&type=template&id=795010c3&scoped=true&"
import script from "./res-label.vue?vue&type=script&lang=js&"
export * from "./res-label.vue?vue&type=script&lang=js&"
import style0 from "./res-label.vue?vue&type=style&index=0&id=795010c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795010c3",
  null
  
)

export default component.exports